const hr = {
    common: {
        history: "povijesna verzija"
    }
};
export default hr;



// WEBPACK FOOTER //
// ./src/i18n/langs/hr.js